'use client';

import { useEffect } from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';
import BodyMedium from '../typography/BodyMedium';
import BodyStrong from '../typography/BodyStrong';
import Copy from '../svg-icons/Copy';
import { PdpInfoDTO } from '@/types/models';
import { useCopyToClipboard } from '@/hooks/useCopyToClipboard';
import { showToast } from '@/ui/kit/components/toast/showToast';
interface PlanInfoSummaryProps {
  data: PdpInfoDTO;
  hasDetail?: boolean;
}
const FinancialSummary = ({
  data,
  hasDetail
}: PlanInfoSummaryProps) => {
  const items = {
    duration: ' مدت مشارکت',
    financialInstitution: ' نهاد مالی',
    planType: ' نوع طرح',
    profitPerMonth: ' نحوه پرداخت سود',
    persianConfirmedSymbol: 'نماد طرح',
    companyName: 'نام سکو',
    foundRaiserName: ' متقاضی '
  };
  const [copiedText, copy] = useCopyToClipboard();
  useEffect(() => {
    if (copiedText) {
      showToast({
        message: 'کپی شد'
      });
    }
  }, [copiedText]);
  const gotoUrl = (event: React.MouseEvent<HTMLButtonElement>, url: string) => {
    event.preventDefault();
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation?.();
    const link = document.createElement('a');
    link.href = url;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const handleCopy = (e: React.MouseEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation?.();
    copy(data?.persianConfirmedSymbol || '');
  };
  return <Box sx={{
    zIndex: '1',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    width: '100%',
    px: 'var(--spacing_m)'
  }} data-sentry-element="Box" data-sentry-component="FinancialSummary" data-sentry-source-file="FinancialSummary.tsx">
      <Stack sx={{
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      gap: 'var(--spacing_xs)',
      borderBottom: '1px dashed ',
      borderColor: 'stroke.stroke2',
      py: 'var(--spacing_xs)'
    }} data-sentry-element="Stack" data-sentry-source-file="FinancialSummary.tsx">
        <Typography variant='caption' data-sentry-element="Typography" data-sentry-source-file="FinancialSummary.tsx">{items?.companyName}</Typography>
        <BodyStrong data-sentry-element="BodyStrong" data-sentry-source-file="FinancialSummary.tsx">{'زیما'}</BodyStrong>
      </Stack>
      <Stack sx={{
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      gap: 'var(--spacing_xs)',
      borderBottom: '1px dashed ',
      borderColor: 'stroke.stroke2',
      py: 'var(--spacing_xs)'
    }} data-sentry-element="Stack" data-sentry-source-file="FinancialSummary.tsx">
        <Typography variant='caption' data-sentry-element="Typography" data-sentry-source-file="FinancialSummary.tsx">{items?.financialInstitution}</Typography>

        <BodyMedium color='primary.main' data-sentry-element="BodyMedium" data-sentry-source-file="FinancialSummary.tsx">
          {data?.financialInstitution}
        </BodyMedium>
      </Stack>
      <Stack sx={{
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      gap: 'var(--spacing_xs)',
      borderBottom: '1px dashed ',
      borderColor: 'stroke.stroke2',
      py: 'var(--spacing_xs)'
    }} data-sentry-element="Stack" data-sentry-source-file="FinancialSummary.tsx">
        <Typography variant='caption' data-sentry-element="Typography" data-sentry-source-file="FinancialSummary.tsx">{items?.foundRaiserName}</Typography>
        <BodyStrong data-sentry-element="BodyStrong" data-sentry-source-file="FinancialSummary.tsx">{data?.fundraiserName?.name}</BodyStrong>
      </Stack>
      <Stack sx={{
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      gap: 'var(--spacing_xs)',
      borderBottom: '1px dashed ',
      borderColor: 'stroke.stroke2',
      py: 'var(--spacing_xs)'
    }} data-sentry-element="Stack" data-sentry-source-file="FinancialSummary.tsx">
        <Typography variant='caption' data-sentry-element="Typography" data-sentry-source-file="FinancialSummary.tsx">{items?.planType}</Typography>
        <BodyStrong data-sentry-element="BodyStrong" data-sentry-source-file="FinancialSummary.tsx">{data?.planType}</BodyStrong>
      </Stack>

      <Stack sx={{
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      gap: 'var(--spacing_xs)',
      borderBottom: '1px dashed ',
      borderColor: 'stroke.stroke2',
      py: 'var(--spacing_xs)'
    }} data-sentry-element="Stack" data-sentry-source-file="FinancialSummary.tsx">
        <Typography variant='caption' data-sentry-element="Typography" data-sentry-source-file="FinancialSummary.tsx">
          {items?.persianConfirmedSymbol}
          <Button variant='text' onClick={e => gotoUrl(e, 'https://cf.ifb.ir/Home/ViewProject')} data-sentry-element="Button" data-sentry-source-file="FinancialSummary.tsx">
            <Typography zIndex={100} variant='caption' data-sentry-element="Typography" data-sentry-source-file="FinancialSummary.tsx">
              {' '}
              (قابل استعلام)
            </Typography>
          </Button>
        </Typography>

        {data?.persianConfirmedSymbol ? <BodyStrong sx={{
        display: 'flex'
      }}>
            {data?.persianConfirmedSymbol}
            <Box onClick={(e: React.MouseEvent<HTMLDivElement>) => {
          handleCopy(e);
        }} sx={{
          px: 'var(--spacing_xxs)',
          display: 'flex',
          zIndex: '1100',
          alignItems: 'center'
        }}>
              <Copy />
            </Box>
          </BodyStrong> : <BodyStrong>- </BodyStrong>}
      </Stack>
      {hasDetail && <Stack sx={{
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      gap: 'var(--spacing_xs)',
      borderBottom: '1px dashed ',
      borderColor: 'stroke.stroke2',
      py: 'var(--spacing_xs)'
    }}>
          <Typography variant='caption'>{items?.duration}</Typography>
          <BodyStrong variant='bodyStrong__Wallfund'>
            {data?.duration} <Typography variant='caption'> ماه</Typography>
          </BodyStrong>
        </Stack>}
      {hasDetail && <Stack sx={{
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      gap: 'var(--spacing_xs)',
      py: 'var(--spacing_xs)',
      borderBottom: '1px dashed ',
      borderColor: 'stroke.stroke2'
    }}>
          <Typography variant='caption'>{items?.profitPerMonth}</Typography>
          <BodyStrong sx={{
        display: 'flex'
      }}>
            {'هر '}
            {data?.profitPerMonth}
            {'ماه'} -{data?.percentPerMonth}{' '}
            <BodyStrong color='primary.main'>{'%'}</BodyStrong>
          </BodyStrong>
        </Stack>}
    </Box>;
};
export default FinancialSummary;